import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { BrasaToastComponent } from './shared/components/toast/toast.component';
import { ToastModule } from './shared/components/toast/toast.module';
import { ToastrModule } from 'ngx-toastr';
import { CURRENCY_MASK_CONFIG } from 'ng2-currency-mask';
import { CustomCurrencyMaskConfig } from './shared/components-config/currency-mask/custom-currency-mask-config';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { RequestInterceptor } from './core/auth/request.interceptor';
import { CustomEncodeHttpParamsInterceptor } from './shared/components-config/custom-encode-http-params';
import { DateInterceptorService } from './shared/data-interceptor/data-interceptor.service';
import { DashboardModule } from './main/dashboard/dashboard.module';
import { providePrimeNG } from 'primeng/config';
import { NgSelectConfig } from '@ng-select/ng-select';
import { TooltipModule } from './shared/directives/tooltip/tooltip.module';

registerLocaleData(localePt, 'pt');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    TooltipModule,
    BrowserAnimationsModule,
    ToastModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      toastComponent: BrasaToastComponent,
      countDuplicates: true,
      tapToDismiss: false,
      preventDuplicates: true,
      progressBar: true,
      progressAnimation: 'decreasing',
      timeOut: 5000
    }),
    AppRoutingModule,
    CoreModule,
    DashboardModule,
  ],
  exports: [],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    { provide: HTTP_INTERCEPTORS, useClass: CustomEncodeHttpParamsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DateInterceptorService, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({ theme: 'none' }),
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(ngSelectConfig: NgSelectConfig) {
    ngSelectConfig.notFoundText = 'Nada encontrado';
    ngSelectConfig.typeToSearchText = 'Digite para buscar';
    ngSelectConfig.addTagText = 'Criar:';
    ngSelectConfig.loadingText = 'Carregando…';
    ngSelectConfig.clearAllText = 'Limpar';
  }
}
